var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"icon":"fad fa-users-crown","title":"Subjekty"}}),_c('SubjectGrid')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }